/**
 * Legacy feature that sends a healthy message to the parent iframe.
 */
export function start() {
  setInterval(() => {
    window.parent.postMessage(new Date(), '*');
  }, 10000);
}
